module.exports = __webpack_public_path__ + "static/media/mosymphony@2x-1.b7766ecb.png";